import { Core } from "@faire/design-tokens";
import { trackHelpCenterSwitchGuideClick } from "@faire/web-api/events/helpCenter/click/switchGuide";
import brands from "@faire/web-api/routes/support/brands";
import retailers from "@faire/web-api/routes/support/retailers";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
export var BrandRetailerMutualLink = function BrandRetailerMutualLink(_ref) {
  var isBrandPath = _ref.isBrandPath;
  return /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.subdued
  }, isBrandPath ? /*#__PURE__*/React.createElement(LinkToRetailers, null) : /*#__PURE__*/React.createElement(LinkToBrands, null));
};
var LinkToRetailers = function LinkToRetailers() {
  return /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "v2NxjX",
    defaultMessage: "Not a brand? <LinkFormatting>Switch to Retailer Guides</LinkFormatting>",
    values: {
      LinkFormatting: MutualLinkToRetailers
    }
  });
};
var LinkToBrands = function LinkToBrands() {
  return /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "/L+QB5",
    defaultMessage: "Not a retailer? <LinkFormatting>Switch to Brand Guides</LinkFormatting>",
    values: {
      LinkFormatting: MutualLinkToBrands
    }
  });
};
var MutualLinkToRetailers = function MutualLinkToRetailers(chunks) {
  return /*#__PURE__*/React.createElement(MutualLink, {
    "data-test-id": "switch-to-retailer-link",
    to: retailers(),
    onClick: function onClick() {
      return trackHelpCenterSwitchGuideClick("retailer");
    }
  }, chunks);
};
var MutualLinkToBrands = function MutualLinkToBrands(chunks) {
  return /*#__PURE__*/React.createElement(MutualLink, {
    "data-test-id": "switch-to-brand-link",
    to: brands(),
    onClick: function onClick() {
      return trackHelpCenterSwitchGuideClick("brand");
    }
  }, chunks);
};
var MutualLink = styled(Link).withConfig({
  displayName: "BrandRetailerMutualLink__MutualLink"
})(["position:relative;&:after{content:\"\";display:block;position:absolute;left:0px;bottom:-2px;width:100%;height:1px;background-color:", ";}"], Core.surface.disabled);